import {Result} from './Result'
import {HttpError} from './Http'

export type OptionalWebData<T> = NotAsked | Loading | Failure | Success<T>

export interface NotAsked {
    readonly type: 'NotAsked'
}

export interface Loading {
    readonly type: 'Loading'
}

export interface Failure {
    readonly type: 'Failure'
    readonly error: HttpError
}

export interface Success<T> {
    readonly type: 'Success'
    readonly value: T
}

export function fromResult<T>(
    result: Result<HttpError, T>,
): OptionalWebData<T> {
    switch (result.type) {
        case 'Ok':
            return {
                type: 'Success',
                value: result.value,
            }
        case 'Err':
            return {
                type: 'Failure',
                error: result.error,
            }
    }
}

export function map<A, B>(
    fn: (value: A) => B,
    webData: OptionalWebData<A>
): OptionalWebData<B> {
    switch (webData.type) {
        case 'Success':
            return {
                type: 'Success',
                value: fn(webData.value),
            }
        default:
            return webData
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/OptionalWebData.ts